<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
        <el-tab-pane label="积分明细" name="second"></el-tab-pane>
        <el-tab-pane label="积分兑换现金记录" name="points-money"></el-tab-pane>
        <el-tab-pane label="积分兑换学分记录" name="points-credit"></el-tab-pane>
        <el-tab-pane label="积分设置" name="first"></el-tab-pane>

    </el-tabs>
      <!--积分明细-->
      <Log v-if="activeName == 'second'"></Log>
      <pointsMoney v-if="activeName == 'points-money'"></pointsMoney>
      <pointsCredit v-if="activeName == 'points-credit'"></pointsCredit>
    <!--积分设置-->
    <Setting v-if="activeName == 'first'"></Setting>


  </div>
</template>
<script>
import Setting from './part/Setting';
import Log from './part/Log';
import pointsMoney from './part/points-money';
import pointsCredit from './part/points-credit';
export default {
  components: {
    Setting,
    Log,
      pointsMoney,
      pointsCredit,
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'second'
    };
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/points/index.vue